import * as yup from 'yup';
import IChangeDestination from '../../interfaces/changeDestination/changeDestination';

export const initialValues: IChangeDestination = {
	// ... your initial form values
	shipmentId: '',
	email: '',
	mobileNumber: '',
	deliveryChoice: null,
	additionalText: '',
	postalCode: null,
};

export const ChangeDestinationFormSchema = yup.object().shape({
	shipmentId: yup.string().required('generalForm:required'),
	deliveryChoice: yup.object().required('generalForm:required').nullable(),
	postalCode: yup.object().required('generalForm:required').nullable(),
	additionalText: yup
		.string()
		.when('deliveryChoice', { is: { value: 'HomeDelivery' }, then: yup.string().required('generalForm:required') }),
});
